module.exports = __webpack_public_path__ + "static/media/pic.1cfa729d.jpg";